import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useSubformCommentsApi Hook
 *
 * Pure API hook for subform-level comment operations.
 * All calls target /api/subform-comments endpoints.
 *
 * @returns {{ addComment: Function, updateComment: Function, deleteComment: Function, getCommentsBySubform: Function }}
 */
const useSubformCommentsApi = () => {
  const addComment = useCallback(
    async ({ requestId, subFormId, formId, comment, attachedFiles }) => {
      const response = await axiosInstance.post('/api/subform-comments/', {
        requestId,
        subFormId,
        formId,
        comment,
        attachedFiles,
      });
      return response.data;
    },
    []
  );

  const updateComment = useCallback(
    async ({
      id,
      comment,
      attachedFilesToAdd,
      attachedFilesToRemove,
      requestId,
    }) => {
      const response = await axiosInstance.put(`/api/subform-comments/${id}`, {
        comment,
        attachedFilesToAdd,
        attachedFilesToRemove,
        requestId,
      });
      return response.data;
    },
    []
  );

  const deleteComment = useCallback(async ({ id, requestId }) => {
    const response = await axiosInstance.delete(`/api/subform-comments/${id}`, {
      data: { requestId },
    });
    return response.data;
  }, []);

  const getCommentsBySubform = useCallback(
    async (requestId, subFormId, formId) => {
      let url = `/api/subform-comments/request/${requestId}/subform/${subFormId}`;
      if (formId) {
        url += `?form_id=${formId}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    },
    []
  );

  return { addComment, updateComment, deleteComment, getCommentsBySubform };
};

export default useSubformCommentsApi;
